export default "__VITE_ASSET__D50nMZAC__"